import { defineMessages } from 'react-intl';

const translations = {
  itemDrawer: {
    title: {
      id: 'calculationInvoiceForm.itemDrawer.title',
      defaultMessage: 'Edit item',
      description: 'Title of the edit item drawer in the invoice calculation form',
    },
  },
};

export default defineMessages(translations);
